import { render } from "./menu.vue?vue&type=template&id=0cf41153&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=0cf41153&scoped=true&lang=css"
import "./menu.vue?vue&type=style&index=1&id=0cf41153&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf41153"]])

export default __exports__